const APP_MODE = process.env.REACT_APP_MODE
const MAINTENANCE_MODE = false;
const BACKEND_HEALTH_CHECK_INTERVAL_MS = 30000;

const API_URLS = {
  development: 'http://localhost:5000',
  live: 'https://api.seatifyai.com',
};

const config = {
  MODE: APP_MODE,
  MAINTENANCE_MODE,
  BACKEND_HEALTH_CHECK_INTERVAL_MS,
  API_URL: APP_MODE === 'development' ? API_URLS.development : API_URLS.live,
  S3_PUBLIC_BASE_URL: process.env.REACT_APP_S3_PUBLIC_BASE_URL || '',
};

export default config;
